import React from "react";
import { ChevronRight, ChevronLeft, ClipboardCheck } from "lucide-react";
import { usd } from "../../lib/api";
import { cardCls } from "./FormBits";

export function WizardProgress({ steps, step }) {
  return (
    <div data-testid="registration-progress-bar" className="mb-8">
      <div className="flex items-center gap-2">
        {steps.map((s, i) => (
          <React.Fragment key={s}>
            <div className={`flex items-center gap-2 ${i <= step ? "text-[#008057]" : "text-slate-400"}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${i <= step ? "bg-[#008057] text-white" : "bg-slate-200 text-slate-500"}`}>{i + 1}</div>
              <span className="hidden sm:inline text-sm font-semibold">{s}</span>
            </div>
            {i < steps.length - 1 && <div className={`flex-1 h-1 rounded-full ${i < step ? "bg-[#008057]" : "bg-slate-200"}`} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export function WizardNav({ step, last, onBack, onNext, onCheckout }) {
  return (
    <div className="flex items-center justify-between pt-2">
      {step > 0 ? (
        <button data-testid="wizard-back" onClick={onBack} className="rounded-full border-2 border-[#E2EBF0] px-6 py-2.5 font-bold text-slate-600 flex items-center gap-1 hover:border-[#008057]"><ChevronLeft size={18} /> Back</button>
      ) : <span />}
      {step < last ? (
        <button data-testid="wizard-next" onClick={onNext} className="rounded-full bg-[#008057] hover:bg-[#054D34] text-white px-8 py-2.5 font-bold flex items-center gap-1 transition-colors">Continue <ChevronRight size={18} /></button>
      ) : (
        <button data-testid="proceed-to-checkout" onClick={onCheckout} className="rounded-full bg-[#F3C242] hover:brightness-105 text-[#03281B] px-8 py-2.5 font-bold flex items-center gap-1 transition-all gold-glow">Proceed to Checkout <ChevronRight size={18} /></button>
      )}
    </div>
  );
}

export function ReviewStep({ quote, participants, guardian }) {
  return (
    <div className="space-y-6">
      <div className={cardCls}>
        <div className="flex items-center gap-2 font-display font-bold text-lg text-[#03281B] mb-4"><ClipboardCheck size={20} className="text-[#008057]" /> Review Your Registration</div>
        <div className="text-sm text-slate-600 mb-4">Category: <strong className="text-[#03281B]">{quote?.category?.name}</strong> &middot; {usd(quote?.category?.price)} per participant</div>
        {quote?.participants?.map((p, i) => (
          <div key={participants[i]?._k || p.name} className="border-t border-slate-100 py-3">
            <div className="font-semibold text-[#03281B]">{p.name}</div>
            {p.items.map((it) => (
              <div key={it.label} className="flex justify-between text-sm text-slate-600"><span>{it.label} <span className="text-slate-400">- {it.detail}</span></span><span className="font-mono">{usd(it.amount)}</span></div>
            ))}
            <div className="flex justify-between text-sm font-semibold mt-1"><span>Subtotal</span><span>{usd(p.subtotal)}</span></div>
          </div>
        ))}
        <div className="flex justify-between font-display font-extrabold text-xl text-[#03281B] border-t-2 border-[#008057] pt-3 mt-2"><span>Total</span><span>{usd(quote?.total)}</span></div>
      </div>
      <p className="text-sm text-slate-500">Guardian: {guardian.first_name} {guardian.last_name} &middot; {guardian.email} &middot; {guardian.phone}</p>
      {guardian.referral_code && <p data-testid="review-referral" className="text-sm text-slate-500">Referral code: <strong className="font-mono text-[#03281B]">{guardian.referral_code}</strong>{guardian.referral_partner ? ` (${guardian.referral_partner})` : ""}</p>}
    </div>
  );
}
